import { useEffect } from 'react';

/**
 * Hook to disable body scrolling when a modal or overlay is open
 * @param isScrollDisabled - Boolean to determine if body scrolling should be disabled
 */
const useScrollDisable = (isScrollDisabled: boolean): void => {
  useEffect(() => {
    // Save the original body style
    const originalStyle = window.getComputedStyle(document.body).overflow;
    
    if (isScrollDisabled) {
      // Disable scrolling
      document.body.style.overflow = 'hidden';
      
      // On iOS Safari, we need additional measures to prevent background scrolling
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    }
    
    // Cleanup function to restore original body style when component unmounts or isScrollDisabled changes
    return () => {
      if (isScrollDisabled) {
        const scrollY = document.body.style.top;
        document.body.style.overflow = originalStyle;
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        
        // Restore scroll position
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    };
  }, [isScrollDisabled]);
};

export default useScrollDisable;